import React from 'react';
import { Counter, Checkbox } from '@homeexchange/design';
import i18n from '../../../../i18n';
import styles from './residence.module.scss';
export var ResidenceSize = function (_a) {
    var putUpBedValue = _a.putUpBedValue, bedroomValue = _a.bedroomValue, bathroomValue = _a.bathroomValue, bedroomChangeHandler = _a.bedroomChangeHandler, bathroomChangeHandler = _a.bathroomChangeHandler, putUpBedChangeHandler = _a.putUpBedChangeHandler;
    var handleBedroomChange = function (val) {
        bedroomChangeHandler({ target: { name: 'bedrooms', value: val } });
    };
    var handleBathroomChange = function (val) {
        bathroomChangeHandler({ target: { name: 'bathrooms', value: val } });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles['bloc-counter'] },
            React.createElement(Counter, { label: i18n.t('search:filter.bedrooms'), minValue: 0, inputInitialValue: bedroomValue !== null && bedroomValue !== void 0 ? bedroomValue : 0, onChange: handleBedroomChange })),
        React.createElement("div", { className: styles['bloc-counter'] },
            React.createElement(Counter, { label: i18n.t('search:filter.bathrooms'), minValue: 0, inputInitialValue: bathroomValue !== null && bathroomValue !== void 0 ? bathroomValue : 0, onChange: handleBathroomChange })),
        React.createElement("div", { className: styles['no-bed-up'] },
            React.createElement(Checkbox, { name: "filters", value: "no-bed-up", onChange: putUpBedChangeHandler, label: i18n.t('search:filter.no-bed-up'), checked: putUpBedValue }))));
};
